(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/compare-numbergames/assets/javascripts/compare-games.js') >= 0) return;  svs.modules.push('/widgets/compare-numbergames/assets/javascripts/compare-games.js');

'use strict';

svs.widget = svs.widget || {};
svs.widget.compare_numbergames = svs.widget.compare_numbergames || {};
svs.widget.compare_numbergames.init = svs.tur.compare_games.init;

 })(window);